export interface returnType {
    isLoading: boolean,
    isSuccess: boolean,
    isFailure: boolean,
}
export const request: returnType = {
    isLoading: true,
    isSuccess: false,
    isFailure: false,
};

export const success: returnType = {
    isLoading: false,
    isSuccess: true,
    isFailure: false,
};

export const failure: returnType = {
    isLoading: false,
    isSuccess: false,
    isFailure: true,
};


const DateFilter = {
    TODAY: 'today',
    THIS_WEEK: 'thisweek',
    LAST_WEEK: 'lastweek',
    THIS_MONTH: 'thismonth',
    LAST_MONTH: 'lastmonth',
    THIS_YEAR: 'thisyear',
    LAST_YEAR: 'lastyear',
    CUSTOM: 'custom'
} as const;

export const DATE_FILTER_OPTIONS = [
    { value: DateFilter.TODAY, label: 'Today' },
    { value: DateFilter.THIS_WEEK, label: 'This Week' },
    { value: DateFilter.LAST_WEEK, label: 'Last Week' },
    { value: DateFilter.THIS_MONTH, label: 'This Month' },
    { value: DateFilter.LAST_MONTH, label: 'Last Month' },
    { value: DateFilter.THIS_YEAR, label: 'This Year' },
    { value: DateFilter.LAST_YEAR, label: 'Last Year' },
    { value: DateFilter.CUSTOM, label: 'Custom Range' }
];

export const PERIOD_OPTIONS = [
    // { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    // { value: 'quartely', label: 'Quarterly' },
    { value: 'yearly', label: 'Yearly' },
];

export const PLAN_ROLE = [
    { value: "studio", label: "Studio" },
    { value: "photographer", label: "Freelance Photographer" },
]

export const role = {
    SUPER_ADMIN_ROLE: "superadmin",
    STUDIO_ADMIN_ROLE: "studioadmin",
    STUDIO_MANAGER_ROLE: "studiomanager",
    STUDIO_PHOTOGRAPHER_ROLE: "studiophotographer",
    FREELANCE_PHOTOGRAPHER_ROLE: "freelancephotographer",

};

export const roleName = {
    SUPER_ADMIN_NAME: "Super Admin",
    STUDIO_ADMIN_NAME: "Studio Admin",
    STUDIO_MANAGER_NAME: "Studio Manager",
    STUDIO_PHOTOGRAPHER_NAME: "Studio Manager",
    FREELANCE_PHOTOGRAPHER_NAME: "Freelance Photographer",
};

export const sessionKeys = {
    pspInviteDetailKey: "psp_invite_details",
    SAS_STORAGE_KEY: "azure_blob_sas",

}
export const localKeys = {
    authData: "AUTHDATA",
    defaultStorageKey: "psp_cookie_consent",
    deviceId:"psp_device_id"
}

export const KYC_PROTECTED_ROUTES = [
    "/dashboard",
    "/events",
    "/enquiries",
    "/availability",
    "/users",
    "/studios",
    "/review",
    "/album-templates"
];

export const ACTIVE_SUBSCRIPTION_STATUS = ["active", "authenticated", "grace_period", "paused"];

export const EXPIRED_SUBSCRIPTION_STATUS = ["expired"];

export const KYC_DOCUMENTS = {
    aadhaar: {
        label: "Aadhaar",
        status: "available",
    },
    pan: {
        label: "PAN",
        status: "upcoming",
    },
    dl: {
        label: "Driving License",
        status: "upcoming",
    },
} as const;

export type KycDocumentType = keyof typeof KYC_DOCUMENTS;